import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson22: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson21"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Trading View Guide
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson23"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[5.25rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-gainsboro-100 font-dm-sans">

        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Charting Tool</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The price action of an asset is displayed in a chart. The tools in
            which these charts are displayed are charting tools. By using a
            charting tool, you minimise the risk when you trade. Instead of
            trading blindly, it is much better to mark levels, trends, and
            targets on a chart. There are several types of charting tools, but
            here we will take TradingView as an example. The topics related to
            TradingView explained below, are the only ones that are important
            for now. It is not necessary to use indicators.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>TradingView Beginner's Guide</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The TradingView interface consists of a large number of tools. This
            can be overwhelming at first sight. Most of the tools you will
            probably never use. The tools you will use will all be listed here.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Chart</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The chart is what it's all about. In a chart, you see the price
            movement of an asset. In this case, the price movement of Bitcoin.
            The price movement is shown in candles. These candles together form
            the line you see on the chart.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Drawing Tools</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Drawing tools allow you to draw marks on the chart. The tools you
            use most often can be pinned in your favorite drawing tools bar.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[47.5rem] object-cover"
          alt=""
          src="/i93@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Favorite Drawing Tools Toolbar (FDTT)</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                If you want to trade efficiently, a properly set FDTT is
                essential. In the example below, the FDTT is highlighted. You
                can add tools to the FDTT by clicking on the star next to a
                drawing tool. An explanation of the tools in the example FDTT
                follows down below.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[47.5rem] object-cover"
          alt=""
          src="/i94@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <b>{`Cross: `}</b>
          <span>drag through the chart.</span>
        </div>
        <img
          className="relative w-[90.19rem] h-[12rem] object-cover"
          alt=""
          src="/i95@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Horizontal ray:</b>
            <span>
              {" "}
              place a horizontal line on the chart (support, resistance, levels,
              targets).
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            After placing the horizontal ray, you can click on it. A menu
            appears where you can adjust the style, text, coordinates, and
            visibility. You can also save templates here.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[12rem] object-cover"
          alt=""
          src="/i96@2x.png"
        />
        <img
          className="relative w-[90.19rem] h-[28.75rem] object-cover"
          alt=""
          src="/i97@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Ray:</b>
            <span>
              {" "}
              place a diagonal line on the chart (support, resistance, trends).
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            You can also click on a ray. The same menu appears, but the options
            you now have to choose from differ. The default settings are perfect
            to use.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[12rem] object-cover"
          alt=""
          src="/i98@2x.png"
        />
        <img
          className="relative w-[90.19rem] h-[51.56rem] object-cover"
          alt=""
          src="/i99@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Text:</b>
            <span> place notes on the chart.</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            By clicking on the text tool and then on start, a menu appears. In
            this menu, you can change the text, colour, size, and other details.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[12rem] object-cover"
          alt=""
          src="/i100@2x.png"
        />
        <img
          className="relative w-[90.19rem] h-[38.56rem] object-cover"
          alt=""
          src="/i101@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`Short position: `}</b>
            <span>places two areas. Red area: loss. Green area: profit.</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            By clicking on the short position, a menu appears. It is useful to
            enter the profit level and stop level here so that you know in which
            direction your trade is going and how long it will be before your
            Profit or stop level is realized.
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[12rem] object-cover"
          alt=""
          src="/i102@2x.png"
        />
        <img
          className="relative w-[90.19rem] h-[43.94rem] object-cover"
          alt=""
          src="/i103@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <b>Long position:</b>
          <span>
            {" "}
            places two areas. Red area: loss. Green area: profit. By clicking on
            the Long Position, a menu appears. It is useful to enter the Profit
            Level and Stop Level here so that you know in which direction your
            trade is going and how long it will be before your Profit or Stop
            Level is realized.
          </span>
        </div>
        <img
          className="relative w-[90.19rem] h-[12rem] object-cover"
          alt=""
          src="/i104@2x.png"
        />
        <img
          className="relative w-[90.19rem] h-[42.31rem] object-cover"
          alt=""
          src="/i105@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Symbol Search</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Symbol search allows you to search for the asset you want to
                research or trade. Click on the asset (in this case BTCUSDT, top
                left) and symbol search will appear. You can search for stocks,
                futures, forex, crypto, indices, bonds, and economy related
                assets.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[37.38rem] object-cover"
          alt=""
          src="/i106@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Timeframes</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                In level 1, you learned about timeframes. You can choose between
                different timeframes by clicking on the box next to the asset.
                In the example, this is the "D" because "1 day" is selected as
                the timeframe.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[37.38rem] object-cover"
          alt=""
          src="/i107@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Candles</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                You can personalize your chart by choosing candles. It is
                recommended not to change the default settings. Use "Candles" or
                "Hollow Candles".
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[37.38rem] object-cover"
          alt=""
          src="/i108@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Alert</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                By setting an alert, you will receive a notification when an
                asset has reached price X. By X, we mean the price you enter. It
                is advisable to install the TradingView app. If you log in to
                the app with the same account as on your desktop, you will
                receive notifications on your phone.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[47.69rem] object-cover"
          alt=""
          src="/i109@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Other Tools</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Other tools can be found on the right-hand side of the
                interface. Navigate through these yourself. See what options
                there are and which ones you could use. What works for person 1
                may not work for person 2. That is why it is important to find
                out what works for you.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[90.19rem] h-[47.69rem] object-cover"
          alt=""
          src="/i110@2x.png"
        />
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson23">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center max-md:pb-[1.3rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson22;
